import { getPathByString, GetPathByStringOptions } from '@griply/utils';
import { useMemo } from 'react';
import { useLocation } from 'react-router';

export const useActivePath = (options?: GetPathByStringOptions) => {
  const { pathname: currentPathname } = useLocation();

  return useMemo(
    () => getPathByString(currentPathname, options),
    [currentPathname, options],
  );
};
